export default "__VITE_ASSET__BQCzJ7XC__"